import { Space } from '@sravni/react-design-system/lib/Space';

import { BadgeListItem, type BadgeListItemProps } from './BadgeListItem';

type BadgeListProps = {
  badges?: BadgeListItemProps[];
};

export const BadgeList = (props: BadgeListProps) => {
  const { badges } = props;

  if (!badges?.length) {
    return null;
  }

  return (
    <Space
      size={8}
      wrap
    >
      {badges.map((badge) => (
        <BadgeListItem
          {...badge}
          key={`tooltip_${badge.title}_${badge.color}_${badge.variant}`}
        />
      ))}
    </Space>
  );
};
